import classnames from 'classnames';
import { Label } from 'components/InputsMex/containers/components';
import React, { memo } from 'react';
import { TARJETAS_PROPS } from 'utils/constants/TARJETAS';

const SeleccionarTarjeta = ({ tarjetaSeleccionada, setTarjetaSeleccionada, disabled = false }) => {
  return (
    <div className="col-12 mt-4">
      <Label style={{ fontSize: '20px' }}>Seleccionar tarjeta:</Label>
      <div className="d-flex flex-column flex-lg-row">
        <ButtonTarjeta
          setter={setTarjetaSeleccionada}
          value={tarjetaSeleccionada}
          name="visa"
          label="VISA"
          disabled={disabled}
        />
        <ButtonTarjeta
          setter={setTarjetaSeleccionada}
          value={tarjetaSeleccionada}
          name="mastercard"
          label="MASTER CARD"
          // style={{ width: '11rem' }}
          disabled={disabled}
        />
        <ButtonTarjeta
          setter={setTarjetaSeleccionada}
          value={tarjetaSeleccionada}
          name="amex"
          label="AMEX"
          disabled={disabled}
        />
      </div>
    </div>
  );
};

const ButtonTarjeta = memo(({ setter, value, name, label, style = {}, disabled }) => {
  const handleClick = () => {
    setter(TARJETAS_PROPS[name]);
  };

  return (
    <button
      type="button"
      className={classnames('btn', {
        'btn-outline-primary': value !== name,
        'btn-primary': value === name,
      })}
      disabled={disabled}
      style={{ zIndex: 99, minWidth: '10rem', ...style }}
      onClick={handleClick}
    >
      {label}
    </button>
  );
});

export default SeleccionarTarjeta;
